import { ProcessoAprovacao, FluxoAprovacaoStatus, EtapaAprovacaoFluxoStatus, DecisaoAprovacao, ModoEtapaAprovacao, } from '../generated/backend-enums.js';
export { ProcessoAprovacao, FluxoAprovacaoStatus, EtapaAprovacaoFluxoStatus, DecisaoAprovacao, ModoEtapaAprovacao, };
export const ProcessoAprovacaoMap = {
    [ProcessoAprovacao.CUSTO_PROJETO]: 'Custo de Projeto',
    [ProcessoAprovacao.CUSTO_BUDGET]: 'Orçamento de Custo Fixo',
};
export const FluxoAprovacaoStatusMap = {
    [FluxoAprovacaoStatus.EM_ANDAMENTO]: 'Em andamento',
    [FluxoAprovacaoStatus.APROVADO]: 'Aprovado',
    [FluxoAprovacaoStatus.REPROVADO]: 'Reprovado',
    [FluxoAprovacaoStatus.CANCELADO]: 'Cancelado',
};
export const EtapaAprovacaoFluxoStatusMap = {
    [EtapaAprovacaoFluxoStatus.PENDENTE]: 'Pendente',
    [EtapaAprovacaoFluxoStatus.APROVADA]: 'Aprovada',
    [EtapaAprovacaoFluxoStatus.REPROVADA]: 'Reprovada',
    [EtapaAprovacaoFluxoStatus.PULADA]: 'Pulada',
};
export const DecisaoAprovacaoMap = {
    [DecisaoAprovacao.PENDENTE]: 'Pendente',
    [DecisaoAprovacao.APROVADO]: 'Aprovado',
    [DecisaoAprovacao.REPROVADO]: 'Reprovado',
};
export const ModoEtapaAprovacaoMap = {
    [ModoEtapaAprovacao.TODOS]: 'Todos aprovam',
    [ModoEtapaAprovacao.QUALQUER]: 'Qualquer um aprova',
    [ModoEtapaAprovacao.UM_POR_CARGO]: 'Um de cada cargo',
};
